<p class="page-hint">{{ 'pages.settings.aiLimits.intro' | translate }}</p>
<p class="page-hint" *ngIf="loadFailed">{{ 'pages.settings.aiLimits.loadError' | translate }}</p>

<ng-container *ngIf="overview as o">
  <!-- Standard: gilt fuer jeden Nutzer ohne eigenes Limit. -->
  <nb-card>
    <nb-card-header>
      <h6><nb-icon icon="flash-outline"></nb-icon>{{ 'pages.settings.aiLimits.defaultTitle' | translate }}</h6>
    </nb-card-header>
    <nb-card-body>
      <p class="note">{{ 'pages.settings.aiLimits.defaultHint' | translate }}</p>
      <div class="defaults">
        <label *ngFor="let area of o.areas" class="default-field">
          <span class="label">{{ 'pages.settings.aiLimits.area.' + area | translate }}</span>
          <span class="area-hint">{{ 'pages.settings.aiLimits.areaHint.' + area | translate }}</span>
          <input nbInput fieldSize="small" type="number" min="0" data-enter-ignore
                 [value]="o.defaults[area] ?? ''"
                 [placeholder]="'pages.settings.aiLimits.unlimited' | translate"
                 [disabled]="saving['default:' + area]"
                 (change)="saveDefault(area, $any($event.target).value)"
                 (keydown.enter)="$any($event.target).blur()" />
        </label>
      </div>
    </nb-card-body>
  </nb-card>

  <!-- Je Nutzer: eigenes Limit geht vor dem Standard. -->
  <nb-card>
    <nb-card-header>
      <h6><nb-icon icon="people-outline"></nb-icon>{{ 'pages.settings.aiLimits.usersTitle' | translate }}</h6>
    </nb-card-header>
    <nb-card-body>
      <p class="note">
        {{ 'pages.settings.aiLimits.usersHint' | translate: { since: (o.month_start | date: 'dd.MM.yyyy') } }}
      </p>
      <table class="limits-table">
        <thead>
          <tr>
            <th>{{ 'pages.settings.aiLimits.col.user' | translate }}</th>
            <th *ngFor="let area of o.areas">{{ 'pages.settings.aiLimits.area.' + area | translate }}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let row of rows; trackBy: trackRow">
            <td class="user">
              <span class="name">{{ row.name || row.email }}</span>
              <span class="sub">{{ row.email }} · {{ 'pages.settings.aiLimits.role.' + row.role | translate }}</span>
            </td>
            <td *ngFor="let area of o.areas" class="cell">
              <input nbInput fieldSize="small" type="number" min="0" data-enter-ignore
                     [value]="row.areas[area].own_limit ? row.areas[area].limit_credits : ''"
                     [placeholder]="o.defaults[area] !== null
                       ? ('pages.settings.aiLimits.defaultPlaceholder' | translate: { value: o.defaults[area] })
                       : ('pages.settings.aiLimits.unlimited' | translate)"
                     [disabled]="saving[row.user_id + ':' + area]"
                     (change)="saveUser(row, area, $any($event.target).value)"
                     (keydown.enter)="$any($event.target).blur()" />
              <div class="usage">
                <span>
                  {{ credits(row.areas[area].used_milli) | number: '1.0-1' }}
                  <ng-container *ngIf="row.areas[area].limit_credits !== null">
                    / {{ row.areas[area].limit_credits | number }}
                  </ng-container>
                  {{ 'pages.settings.aiLimits.credits' | translate }}
                </span>
                <div class="bar" *ngIf="pct(row.areas[area]) as p">
                  <div class="fill" [class.full]="p >= 100" [class.warn]="p >= 80 && p < 100" [style.width.%]="p"></div>
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </nb-card-body>
  </nb-card>
</ng-container>

<app-page-loader *ngIf="loading && !overview"></app-page-loader>
